import { render, staticRenderFns } from "./GuestsBadge.vue?vue&type=template&id=3ff885c7&scoped=true&"
import script from "./GuestsBadge.vue?vue&type=script&lang=js&"
export * from "./GuestsBadge.vue?vue&type=script&lang=js&"
import style0 from "./GuestsBadge.vue?vue&type=style&index=0&id=3ff885c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff885c7",
  null
  
)

export default component.exports